import type { ColDef } from 'ag-grid-community';
import { CryptoExposedCol } from 'components/underlyingUniverse/columnDefinitions/crypto-exposed-col';
import { EsgEquityEligibilityCol } from 'components/underlyingUniverse/columnDefinitions/esg-eligibility-col';

function getInternalSalesEquityColumnDefinitions(): ColDef[] {
  const allColDefs = [
    {
      field: 'type',
      type: 'string',
      sort: 'asc',
    },
    {
      field: 'name',
      type: 'string',
    },
    {
      field: 'bloombergTickerCode',
      type: 'string',
    },
    {
      field: 'reutersCode',
      type: 'string',
    },
    {
      field: 'isin',
      type: 'string',
    },
    {
      field: 'currency',
      type: 'currency',
    },
    {
      field: 'exchange',
      type: 'string',
    },
    {
      field: 'website',
      type: 'string',
    },
    {
      field: 'esgEligibility',
      type: 'esgEligibility',
      headerComponent: EsgEquityEligibilityCol,
    },
    {
      field: 'cryptoExposed',
      type: 'boolean',
      headerComponent: CryptoExposedCol,
    },
  ] satisfies ColDef[];

  return allColDefs;
}

const externalUserEquityColumnDefinitions: ColDef[] = [
  {
    field: 'type',
    type: 'string',
    sort: 'asc',
  },
  {
    field: 'name',
    type: 'string',
  },
  {
    field: 'bloombergTickerCode',
    type: 'string',
  },
  {
    field: 'reutersCode',
    type: 'string',
  },
  {
    field: 'isin',
    type: 'string',
  },
  {
    field: 'currency',
    type: 'currency',
  },
  {
    field: 'exchange',
    type: 'string',
  },
  {
    field: 'website',
    type: 'string',
  },
];

export function getEquityColumnDefinitions(isInternalUser?: boolean) {
  if (isInternalUser) {
    return getInternalSalesEquityColumnDefinitions();
  }
  return externalUserEquityColumnDefinitions;
}
